export default $products => {
  const getProducts = () => $products.products
  return { getProducts }
}
